import { action, makeObservable, observable } from 'mobx';
import { MenuIconsId } from '../core/constants/menuIconsId';

class MenuSectionStore {
  isShowMenuPopup = false;

  currentPayTableStepCount = 0;

  selectedIconId = MenuIconsId.PayTable;

  constructor() {
    makeObservable(this, {
      selectedIconId: observable,
      isShowMenuPopup: observable,
      currentPayTableStepCount: observable,
      setSelectedIconId: action.bound,
      setIsShowMenuPopup: action.bound,
      setCurrentPayTableStepCount: action.bound,
    });
  }

  setSelectedIconId(id) {
    this.selectedIconId = id;
  }

  setIsShowMenuPopup(bool) {
    this.isShowMenuPopup = bool;
  }

  setCurrentPayTableStepCount(count) {
    this.currentPayTableStepCount = count;
  }
}

export const menuSectionStore = new MenuSectionStore();
